import * as resource from './resource.js';
import * as resourceSearch from './search.js';

export default Stories = (Alpine) => {
  resource.init(Alpine)
  resourceSearch.init(Alpine)
};